import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Modal, Form, Input, Button } from 'semantic-ui-react';
const generateIdFromName = (name) => name
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
const COMPONENT_TYPES = [
    { value: 'audio', label: 'Audio' },
    { value: 'file', label: 'File' },
    { value: 'camera', label: 'Camera' },
    { value: 'chatbot', label: 'Chatbot' },
];
const AddComponentModal = ({ open, onClose, onSave }) => {
    const [form, setForm] = useState({
        name: '',
        componentId: '',
        componentType: 'audio',
    });
    const [idManuallyEdited, setIdManuallyEdited] = useState(false);
    const [errors, setErrors] = useState({});
    useEffect(() => {
        if (!open)
            return;
        setForm({ name: '', componentId: '', componentType: 'audio' });
        setIdManuallyEdited(false);
        setErrors({});
    }, [open]);
    const handleNameChange = (e) => {
        const name = e.target.value;
        setForm(prev => ({
            ...prev,
            name,
            componentId: idManuallyEdited ? prev.componentId : generateIdFromName(name),
        }));
        if (errors.name)
            setErrors(prev => ({ ...prev, name: undefined }));
    };
    const handleIdChange = (e) => {
        setForm(prev => ({ ...prev, componentId: generateIdFromName(e.target.value) }));
        setIdManuallyEdited(true);
        if (errors.componentId)
            setErrors(prev => ({ ...prev, componentId: undefined }));
    };
    const validate = () => {
        const newErrors = {};
        if (!form.name.trim())
            newErrors.name = 'Name is required';
        if (!form.componentId.trim())
            newErrors.componentId = 'Component ID is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSave = async () => {
        if (!validate())
            return;
        try {
            await onSave(form);
            onClose();
        }
        catch (err) {
            if (axios.isAxiosError(err)) {
                const status = err.response?.status;
                const data = err.response?.data;
                if (status === 409) {
                    setErrors(prev => ({
                        ...prev,
                        componentId: data?.error || 'A component with this ID already exists.',
                    }));
                    return;
                }
                if (status === 400) {
                    setErrors(prev => ({ ...prev, componentId: data?.error || 'Invalid component ID.' }));
                    return;
                }
            }
            console.error('Error creating component:', err);
        }
    };
    const handleClose = () => {
        setForm({ name: '', componentId: '', componentType: 'audio' });
        setIdManuallyEdited(false);
        setErrors({});
        onClose();
    };
    return (React.createElement(Modal, { open: open, onClose: handleClose },
        React.createElement(Modal.Header, null, "New AI Component"),
        React.createElement(Modal.Content, null,
            React.createElement(Form, null,
                React.createElement(Form.Field, { error: !!errors.name },
                    React.createElement("label", null,
                        "Name ",
                        React.createElement("span", { style: { color: 'red' } }, "*")),
                    React.createElement(Input, { placeholder: "e.g. Patient Audio Intake", value: form.name, onChange: handleNameChange }),
                    errors.name && React.createElement("div", { style: { color: 'red', fontSize: '0.9em', marginTop: '0.25em' } }, errors.name)),
                React.createElement(Form.Field, { error: !!errors.componentId },
                    React.createElement("label", null,
                        "Component ID ",
                        React.createElement("span", { style: { color: 'red' } }, "*")),
                    React.createElement(Input, { placeholder: "auto-generated from name", value: form.componentId, onChange: handleIdChange }),
                    errors.componentId && (React.createElement("div", { style: { color: 'red', fontSize: '0.9em', marginTop: '0.25em' } }, errors.componentId)),
                    React.createElement("div", { style: {
                            color: '#f57c00',
                            fontSize: '0.85em',
                            marginTop: '0.5em',
                            padding: '0.5em',
                            backgroundColor: '#fff3e0',
                            borderRadius: '4px',
                            borderLeft: '3px solid #ff9800',
                        } },
                        React.createElement("strong", null, "\u26A0\uFE0F Important:"),
                        " The component ID cannot be changed after creation. Pass it as ",
                        React.createElement("code", null, "componentId"),
                        " in your component props.")),
                React.createElement(Form.Field, null,
                    React.createElement("label", null,
                        "Component Type ",
                        React.createElement("span", { style: { color: 'red' } }, "*")),
                    React.createElement("select", { value: form.componentType, onChange: (e) => setForm(prev => ({ ...prev, componentType: e.target.value })), style: {
                            width: '100%',
                            padding: '0.65em',
                            border: '1px solid rgba(34,36,38,.15)',
                            borderRadius: '4px',
                            fontSize: '1em',
                        } }, COMPONENT_TYPES.map(t => (React.createElement("option", { key: t.value, value: t.value }, t.label))))))),
        React.createElement(Modal.Actions, null,
            React.createElement(Button, { onClick: handleClose }, "Cancel"),
            React.createElement(Button, { primary: true, onClick: handleSave }, "Create Component"))));
};
export default AddComponentModal;
